import { render } from "./UnlockModalContent.vue?vue&type=template&id=33a3d289&scoped=true"
import script from "./UnlockModalContent.vue?vue&type=script&lang=ts"
export * from "./UnlockModalContent.vue?vue&type=script&lang=ts"

import "./UnlockModalContent.vue?vue&type=style&index=0&id=33a3d289&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-33a3d289"

export default script